<mat-card class="matches-card">
  <mat-card-header>
    <mat-card-title>Partidos de la Temporada</mat-card-title>
  </mat-card-header>

  <mat-card-content class="matches-card-content">

    <div *ngIf="isLoading" class="loader-container">
      <mat-spinner diameter="40"></mat-spinner>
    </div>

    <div *ngIf="!isLoading && matchesResult">

      <div *ngIf="matchesResult.data.length === 0; else list" class="no-matches-container">
        <mat-icon>event_busy</mat-icon>
        <span>No hay partidos disponibles para esta temporada.</span>
      </div>

      <ng-template #list>
        <div class="list-container">

          <app-statistics-match-card
            *ngFor="let match of matchesResult.data"
            [match]="match">
          </app-statistics-match-card>

        </div>

        <mat-paginator
          *ngIf="matchesResult.total_results > matchesResult.page_size"
          [length]="matchesResult.total_results"
          [pageSize]="matchesResult.page_size"
          [pageIndex]="matchesResult.page - 1"
          (page)="onPageChange($event)"
          showFirstLastButtons>
        </mat-paginator>

      </ng-template>
    </div>

  </mat-card-content>
</mat-card>
